var map = {
	"./dance.png": "a544",
	"./danceVetor.png": "fdc6",
	"./melody.png": "adea",
	"./melodyVetor.png": "4452",
	"./menu/dancevetor-min.png": "30a5",
	"./menu/dancevetor.png": "3d2a",
	"./menu/melodyvetor-min.png": "8c85",
	"./menu/melodyvetor.png": "8e4a",
	"./menu/rhythmvetor-min.png": "5fef",
	"./menu/rhythmvetor.png": "4ae9",
	"./menu/singvetor-min.png": "f25a",
	"./menu/singvetor.png": "44a2",
	"./rhythm.png": "e6f7",
	"./rhythmVetor.png": "2d1e",
	"./sing.png": "57b0",
	"./singVetor.png": "2a49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "656a";